import { SET_PERMISSIONS } from './types';

const initialState = {
  map: {},
};

export default function permissionsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_PERMISSIONS: {
      // localStorage may legitimately hold legacy shapes (the old
      // /su/permissions response was an object, not an array). Coerce
      // anything that isn't a list of permission IDs to an empty array
      // so this dispatch never throws inside the middleware chain.
      const raw = action.payload && action.payload.data;
      const ids = Array.isArray(raw) ? raw : [];
      const map = ids.reduce((acc, permissionId) => {
        acc[permissionId] = { enabled: true };
        return acc;
      }, {});
      return {
        ...state,
        map,
      };
    }
    default:
      break;
  }
  return state;
}
